'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { isAppRoutePath } from '@/constants/app-route-segments';
import { isBasePublicPath, isPotentialPublicPrPagePath } from '@/constants/public-route-patterns';
import { useAuth } from '@/providers/auth-provider';
type AuthProtectionWrapperProps = {
  children: ReactNode;
};

/**
 * A component that checks authentication status for the entire application.
 * If user is not authenticated and tries to access a protected route,
 * they will be redirected to the sign-in page.
 */
export function AuthProtectionWrapper(t0) {
  const $ = _c(9);
  const {
    children
  } = t0;
  const {
    isAuthenticated,
    isLoading
  } = useAuth();
  const pathname = usePathname();
  let t1;
  if ($[0] !== pathname) {
    t1 = isBasePublicPath(pathname) || isPotentialPublicPrPagePath(pathname) || !isAppRoutePath(pathname);
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const pathIsPublic = t1;
  let t2;
  let t3;
  if ($[2] !== isAuthenticated || $[3] !== isLoading || $[4] !== pathIsPublic) {
    t2 = () => {
      if (!isLoading && !isAuthenticated && !pathIsPublic) {
        window.location.replace("/sign-in");
      }
    };
    t3 = [isAuthenticated, isLoading, pathIsPublic];
    $[2] = isAuthenticated;
    $[3] = isLoading;
    $[4] = pathIsPublic;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  if (!isAuthenticated && !pathIsPublic) {
    return null;
  }
  let t4;
  if ($[7] !== children) {
    t4 = <>{children}</>;
    $[7] = children;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}